import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import React from 'react';
import SideNavBarTile from '../../molecules/SideNavBarTile';

export interface ContractSideNavigationProps {
  tabs: any;
  activeIndex: number;
  icons?: any;
   
  handleOnClick: (index: number) => void;
}
const ContractSideNavigationBar: React.FC<ContractSideNavigationProps> = observer(
  ({ tabs, activeIndex, icons, handleOnClick }) => {
    const useStyles = makeStyles()({
      container: {
        width: 'fit-content',
        borderRadius: '0px',
        background: patientAccessTheme.palette.navigationBar?.plainBackground,
        backgroundColor: patientAccessTheme.palette.status.white,
      },
      root: {
        minHeight: '427px',
        height: '100%',
        width: 'fit-content',
        paddingTop: '40px',
        borderLeft: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        overflowY: 'auto',
        overflowX: 'hidden',
        flexWrap: 'nowrap',
      },
      tileGrid: {
        margin: '0px 0px 12px 0px',
      },
      label: {
        fontWeight: 600,
        fontSize: '14px',
        color: patientAccessTheme.palette.navigationBar?.navTitle,
        lineHeight: '24px',
      },
    });
    const { classes } = useStyles();
    return (
      <div className={classes.container}>
        <Grid
          container
          className={classes.root}
          sx={{
            justifyContent: 'space-between',
            flexDirection: 'column',
          }}
        >
          <Grid>
            {tabs.map((item: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <Grid className={classes.tileGrid}>
                    <SideNavBarTile
                      label={item[0]}
                      onClick={() => {
                        handleOnClick(index);
                      }}
                      startIcon={icons[index]}
                      labelTextStyles={classes.label}
                      isActive={activeIndex === index}
                      bgColorString={
                        activeIndex === index
                          ? patientAccessTheme.palette.navigationBar?.titleBg
                          : 'inherit'
                      }
                    />
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Grid>
      </div>
    );
  },
);

export default ContractSideNavigationBar;
